import { NgModule, Component, OnInit, Inject } from '@angular/core';
import { getHttpParams } from '@iv/shared/utils';
import {AppStore} from '@iv/store/app.store';
import * as Redux from 'redux';
import {AppState} from '@iv/store/app.reducer';
import { AdvancedSearchHttpService } from 'app/advanced-search/services/advanced-search-http.service';
import { IStockFutureResponse } from 'app/core/interfaces/stock-future-list.interface';
import {
  Future,
  Instrument
} from '@iv/model/instrument';
import * as TabsActions from '../../../store/tabs/tabs.actions';

@Component({
  selector: 'iv-live-options-calculator-wrap-component',
  template: `<div class="dx-overlay-wrapper create-popup dx-popup-wrapper dx-overlay-content dx-popup-normal dx-resizable" style="position: relative; width: 900px; height: 560px;">
    <div class="dx-popup-content dx-template-wrapper ng-star-inserted" style="box-sizing: border-box;background-color: #272B29;padding:16px;">
       <iv-live-options-calculator [instruments]="instruments"></iv-live-options-calculator>
    </div>
  </div>`,
  styles: [
    ':host ::ng-deep .calculator-search {top: 16px !important}',
    ':host ::ng-deep #optionsCalculatorForm {padding-top: 0 !important}'
  ]
})
export class OptionsCalculatorWrapComponent implements OnInit{
  constructor(
    private advancedSearchHttpService: AdvancedSearchHttpService,
    @Inject(AppStore) private store: Redux.Store<AppState>,
  ) {
    const tab = {
      "id": "_vim9b35wv",
      "type": "instrument",
      "active": true,
      "component": "OptionChainComponent",
      "name": "SPX",
      "description": "S&P 500 Index (SPX)",
      "data": {
        "instrument": {
          "stockId": 9327,
          "regionId": 1,
          "symbol": "SPX",
          "exchange": "CBOE",
          "company": "S&P 500 Index (SPX)",
          "region": "USA",
          "stockType": "I",
          "startDate": "1988-01-04T00:00:00",
          "endDate": "2079-06-06T00:00:00",
          "delisted": false,
          "hasOptions": true
        },
        "chartType": 2,
        "serviceTabs": [
          {
            "active": true,
            "id": 1,
            "component": "OptionMonitorComponent",
            "name": "Options Chain",
            "filters": {
              "expirations": {
                "id": "ALL",
                "value": "All",
                "type": "type"
              },
              "strikesN": "5",
              "type": {
                "name": "Call&Put",
                "value": ""
              },
              "center": 4378.41
            },
            "visibleColumns": [
              "strike",
              "bid",
              "ask",
              "volume",
              "ivint",
              "delta",
              "vega"
            ]
          }
        ],
        "summaryLineVisibleColumns": [
          "price",
          "open",
          "prevClose",
          "changeopen",
          "high",
          "low",
          "bidSize",
          "mid",
          "hv",
          "askSize",
          "stockVol",
          "optVol",
          "ivx",
          "openInterest",
          "callVol",
          "ivxchangeopen",
          "putVol",
          "52whilo"
        ]
      }
    };
    this.store.dispatch(TabsActions.addTab(tab));
    this.store.dispatch(TabsActions.selectTab(tab));
  }
  instruments: Instrument[] = [];
  ngOnInit(){
     const defaultParams = getHttpParams({region: '0', matchingType: 'CONTAINS', sortField: 'SYMBOL'});
      this.advancedSearchHttpService.getListEntities(defaultParams, false)
        .subscribe((data:IStockFutureResponse<Instrument[]>) => {
          this.instruments = data.page.map(instrument => Object.assign(new Instrument(), instrument));
        });
  }
}
